@file:OptIn(InternalResourceApi::class)

package com.xtream.sharedResources.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.RegionQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringArrayResource

private const val MD: String = "composeResources/com.xtream.sharedResources.resources/"

@delegate:ResourceContentHash(-847_676_384)
public val Res.array.decoders: StringArrayResource by lazy {
      StringArrayResource("string-array:decoders", "decoders", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/arrays.commonMain.cvr", 10, 68),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/arrays.commonMain.cvr", 10, 88),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/arrays.commonMain.cvr", 10, 60),
        ResourceItem(setOf(), "${MD}values/arrays.commonMain.cvr", 54, 60),
      ))
    }

@delegate:ResourceContentHash(1_204_134_858)
public val Res.array.decoders_values: StringArrayResource by lazy {
      StringArrayResource("string-array:decoders_values", "decoders_values", setOf(
        ResourceItem(setOf(), "${MD}values/arrays.commonMain.cvr", 10, 43),
      ))
    }

@delegate:ResourceContentHash(-225_585_276)
public val Res.array.language_keys: StringArrayResource by lazy {
      StringArrayResource("string-array:language_keys", "language_keys", setOf(
        ResourceItem(setOf(), "${MD}values/arrays.commonMain.cvr", 115, 58),
      ))
    }

@delegate:ResourceContentHash(-1_395_045_102)
public val Res.array.language_titles: StringArrayResource by lazy {
      StringArrayResource("string-array:language_titles", "language_titles", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/arrays.commonMain.cvr", 79, 168),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/arrays.commonMain.cvr", 99, 144),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/arrays.commonMain.cvr", 71, 104),
        ResourceItem(setOf(), "${MD}values/arrays.commonMain.cvr", 174, 100),
      ))
    }

@delegate:ResourceContentHash(1_794_004_787)
public val Res.array.live_stream_formats: StringArrayResource by lazy {
      StringArrayResource("string-array:live_stream_formats", "live_stream_formats", setOf(
        ResourceItem(setOf(), "${MD}values/arrays.commonMain.cvr", 275, 46),
      ))
    }

@delegate:ResourceContentHash(-732_677_288)
public val Res.array.refresh_data_intervals: StringArrayResource by lazy {
      StringArrayResource("string-array:refresh_data_intervals", "refresh_data_intervals", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/arrays.commonMain.cvr", 248, 111),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/arrays.commonMain.cvr", 244, 123),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/arrays.commonMain.cvr", 176, 79),
        ResourceItem(setOf(), "${MD}values/arrays.commonMain.cvr", 385, 75),
      ))
    }

@delegate:ResourceContentHash(1_591_952_444)
public val Res.array.refresh_data_intervals_values: StringArrayResource by lazy {
      StringArrayResource("string-array:refresh_data_intervals_values", "refresh_data_intervals_values", setOf(
        ResourceItem(setOf(), "${MD}values/arrays.commonMain.cvr", 322, 62),
      ))
    }

@delegate:ResourceContentHash(637_520_707)
public val Res.array.theme_titles: StringArrayResource by lazy {
      StringArrayResource("string-array:theme_titles", "theme_titles", setOf(
        ResourceItem(setOf(), "${MD}values/arrays.commonMain.cvr", 461, 52),
      ))
    }

@delegate:ResourceContentHash(1_984_824_858)
public val Res.array.video_player_resize_mode_titles: StringArrayResource by lazy {
      StringArrayResource("string-array:video_player_resize_mode_titles", "video_player_resize_mode_titles", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/arrays.commonMain.cvr", 360, 137),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/arrays.commonMain.cvr", 368, 185),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/arrays.commonMain.cvr", 256, 121),
        ResourceItem(setOf(), "${MD}values/arrays.commonMain.cvr", 514, 101),
      ))
    }

@delegate:ResourceContentHash(338_679_475)
public val Res.array.video_player_resize_modes: StringArrayResource by lazy {
      StringArrayResource("string-array:video_player_resize_modes", "video_player_resize_modes", setOf(
        ResourceItem(setOf(), "${MD}values/arrays.commonMain.cvr", 616, 63),
      ))
    }

@delegate:ResourceContentHash(-1_320_169_565)
public val Res.array.video_render_mode_titles: StringArrayResource by lazy {
      StringArrayResource("string-array:video_render_mode_titles", "video_render_mode_titles", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/arrays.commonMain.cvr", 498, 95),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/arrays.commonMain.cvr", 554, 103),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/arrays.commonMain.cvr", 378, 87),
        ResourceItem(setOf(), "${MD}values/arrays.commonMain.cvr", 680, 95),
      ))
    }

@delegate:ResourceContentHash(2_086_201_154)
public val Res.array.video_render_modes: StringArrayResource by lazy {
      StringArrayResource("string-array:video_render_modes", "video_render_modes", setOf(
        ResourceItem(setOf(), "${MD}values/arrays.commonMain.cvr", 776, 41),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainArray0Resources(map: MutableMap<String, StringArrayResource>) {
  map.put("decoders", Res.array.decoders)
  map.put("decoders_values", Res.array.decoders_values)
  map.put("language_keys", Res.array.language_keys)
  map.put("language_titles", Res.array.language_titles)
  map.put("live_stream_formats", Res.array.live_stream_formats)
  map.put("refresh_data_intervals", Res.array.refresh_data_intervals)
  map.put("refresh_data_intervals_values", Res.array.refresh_data_intervals_values)
  map.put("theme_titles", Res.array.theme_titles)
  map.put("video_player_resize_mode_titles", Res.array.video_player_resize_mode_titles)
  map.put("video_player_resize_modes", Res.array.video_player_resize_modes)
  map.put("video_render_mode_titles", Res.array.video_render_mode_titles)
  map.put("video_render_modes", Res.array.video_render_modes)
}
